
        require('./index.scss');
        'use strict';

require('module/ie-hack');

require('module/ad/ad-rect');

require('module/loupan-common/recomd-new');

require('module/loupan-common/search-new');

require('module/loupan-common/header-new');

require('module/loupan-common/nav-new');

require('module/loupan-evaluate-new/evaluate-list');

require('module/loupan-common/pagination-new');

require('@front-end/common-module-vm/feedback-dialog');

require('@front-end/common-module-vm/shopping-cart');

require('@front-end/common-module-vm/right-toolbar');

require('module/common/baidu-union');

require('module/common/auto-sem');

require('page/footer.js');

var _redPacket = require('module/ad/red-packet');

var _redPacket2 = _interopRequireDefault(_redPacket);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_redPacket2['default'].init();;
    


// WEBPACK FOOTER //
// ./src/page/loupan-evaluate-new/index.js